const avatarCache = new Map();

export default avatarCache;
